import { render, staticRenderFns } from "./PersonalInfoCollectKind.vue?vue&type=template&id=c39e7af6&scoped=true"
import script from "./PersonalInfoCollectKind.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectKind.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectKind.vue?vue&type=style&index=0&id=c39e7af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39e7af6",
  null
  
)

export default component.exports